import router from './index'
import store from '@/store'
import { getToken } from '@/utils/auth'

// 路由守卫：仅做登录态校验（后端无权限树接口，菜单不做角色级区分）
const whiteList = ['/login', '/404']

router.beforeEach(async (to, from, next) => {
    // 同步浏览器标签标题
    document.title = to.meta && to.meta.title ? `${to.meta.title} - 企业微信会话存档` : '企业微信会话存档'

    const token = getToken()

    // 无 token：白名单放行，其余跳登录
    if (!token) {
        if (whiteList.includes(to.path)) {
            next()
        } else {
            next('/login')
        }
        return
    }

    // 已登录访问 /login，跳回首页
    if (to.path === '/login') {
        next('/userList')
        return
    }

    // 刷新后 Vuex 丢失，从本地缓存恢复用户信息
    if (!store.state.user.userInfo) {
        store.dispatch('user/restoreUserInfo')
    }
    next()
})
